export const formatValueFromInputMoney = (value: string) => {
  let valueFormatted = value;
  if (value.includes(',')) {
    valueFormatted = value.padEnd(
      value.split(',')[1].length === 1 ? value.length + 1 : value.length,
      '0',
    );
  } else {
    valueFormatted = value.padEnd(value.length + 2, '00');
  }

  return valueFormatted;
};
